"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _creators = require("../../../../../redux/creators");

var _utils = require("./../../../../../configuration/utils");

var _constans = require("./../../../../../configuration/constans");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ColorPickerComponent = function ColorPickerComponent() {
  var _colors$;

  var dispatch = (0, _reactRedux.useDispatch)();
  var colors = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct.items;
  });
  var product = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct;
  });

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      currColor = _useState2[0],
      setCurrColor = _useState2[1];

  var changeColor = function changeColor(color) {
    setCurrColor(color); // set images array for selected color

    dispatch((0, _creators.setImagesSlider)(color.images));
  };

  var selectFirstColor = function selectFirstColor() {
    changeColor(colors[0], 0);
  };

  (0, _react.useEffect)(function () {
    if (colors && colors.length > 0 && (product.productType === 'Hearing Instrument' || window.location.href.indexOf(_constans.initialState.accessoryParametr) === -1)) {
      selectFirstColor();
    } else {
      // get first color from general images array when has only 1 variation and it is not device
      dispatch((0, _creators.setImagesSlider)(product.images));
    }
  }, [product]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, colors && /*#__PURE__*/_react["default"].createElement("div", {
    className: "details__variants"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "details__variants__colors"
  }, colors && ((_colors$ = colors[0]) === null || _colors$ === void 0 ? void 0 : _colors$.colorRGB) && colors.map(function (color, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: currColor === color ? 'color active' : 'color',
      key: index,
      tabIndex: 5,
      "aria-label": color.colorName
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "color-border",
      style: {
        background: (0, _utils.dotsBackgroundColor)(color)
      },
      onClick: function onClick() {
        (0, _utils.sendDataLayerEvent)('Colour selector', "".concat(product.title, " ").concat(product.subtitle || '', " > ").concat(color.colorName));
        changeColor(color, index);
      },
      key: index
    }));
  })), currColor && /*#__PURE__*/_react["default"].createElement("div", {
    className: "details__variants__label"
  }, currColor.colorName || currColor.secondaryColorName)));
};

var _default = ColorPickerComponent;
exports["default"] = _default;